// A signature record can name a Storage object that was never uploaded, or
// was deleted. getDownloadURL then rejects storage/object-not-found. The
// field renderer does not catch that promise, so the rejection is reported
// as an unhandled error. An empty record is truthy too: `{}` still has no
// file name, and downloading ".../undefined" is the same missing object.

export const NO_SIGNATURE = "No signature attached";

export function signatureObjectName(record) {
    const file = record?.file;
    return typeof file === "string" && file.length > 0 ? file : null;
}

export function isMissingStorageObject(error) {
    return error?.code === "storage/object-not-found"
        || (typeof error?.message === "string" && error.message.includes("storage/object-not-found"));
}

export async function loadSignatureImage(db, uid, { missing = NO_SIGNATURE } = {}) {
    if (!uid) return missing;
    const record = await db.once(`Userdata/${uid}/Signature`);
    const file = signatureObjectName(record);
    if (!file) return missing;
    try {
        return await db.download(`Userdata/${uid}/Signature/${file}`);
    } catch (error) {
        if (isMissingStorageObject(error)) return missing;
        throw error;
    }
}
